import { styled } from '@mui/material/styles';
import { IconButton, Pagination, Box } from '@mui/material';
import Button from '@mui/material/Button';
import PageBar from '#component/general/page-bar';

export const Cnt = styled('div')(({ theme }) => ({
  padding: theme.spacing(),
  margin: theme.spacing(3, 3, 3, 3),
  [theme.breakpoints.down('md')]: {
    margin: theme.spacing(3, 1, 3, 1),
    padding: 0
  },
  [theme.breakpoints.down('sm')]: {
    margin: 0,
    padding: theme.spacing(1, 1, 0, 1)
  }
}));

export const StyledPageBar = styled(PageBar)(({ theme }) => ({
  position: 'sticky',
  display: 'grid',
  gridTemplateColumns: 'auto 160px',
  gridTemplateAreas: '"filter addBtn"',
  gridGap: theme.spacing(1),
  padding: theme.spacing(2, 4, 2, 4),
  width: '100%',
  backgroundColor: '#EEE',
  zIndex: 1100,
  [theme.breakpoints.down('md')]: {
    position: 'inherit',
    boxShadow: 'none',
    padding: theme.spacing(2, 1, 2, 1),
    gridTemplateAreas: '"addBtn addBtn" "filter filter"',
    gridTemplateColumns: '160px auto',
    gridTemplateRows: 'auto auto'
  },
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(3, 1, 2, 1)
  }
}));

export const AddBtnStyled = styled(Button)({
  gridArea: 'addBtn',
  justifySelf: 'end'
});

export const AddButtonLabel = styled('span')({
  color: 'rgba(0, 0, 0, 0.87)',
  marginLeft: 4
});

// Pagination
export const StyledPagination = styled(Pagination)(({ theme }) => ({
  paddingBottom: theme.spacing(3),
  [theme.breakpoints.down('md')]: {
    paddingTop: theme.spacing(2)
  },
  '& > ul': {
    justifyContent: 'center'
  }
}));

export const PaginationPlaceholder = styled('div')({
  height: 1,
  paddingBottom: '80px'
});

export const ShowMoreContainer = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
});

export const ProjectLink = styled(Button)({
  padding: 0
});

export const StyledModalBox = styled(Box)({
  position: 'absolute',
  top: '0',
  left: '0',
  width: '100%',
  height: '100%',
  backgroundColor: '#fff',
  boxShadow: '0px 11px 15px -7px rgba(0,0,0,0.2),0px 24px 38px 3px rgba(0,0,0,0.14),0px 9px 46px 8px rgba(0,0,0,0.12)',
  padding: 32,
  overflow: 'auto'
});

export const CloseBtn = styled(IconButton)({
  position: 'absolute',
  top: '10px',
  right: '10px'
});

export const ProjectItemBtn = styled(Button)({
  display: 'block',
  marginBottom: '10px'
});
